export default {
  path: 'schedules',
  name: 'schedules',
  redirect: { name: 'schedules.index' },
  children: [
    {
      path: '',
      name: 'schedules.index',
      component: () => import('pages/schedules/IndexPage.vue'),
    },
  ],
}
